import React from 'react'
import keyCodes from 'js/shared/keyCodes';
import BrandingWidget from '../components/branding/BrandingWidget'

// hasTrueValueInObj check if any property in obj is true
// returns true if any property is true
// returns false if all properties are false
// obj is an object with properties of type boolean
// example: hasTrueValueInObj({a: true, b: false}
export const hasTrueValueInObj = (obj) =>{
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === true) {
      return true;
    }
  }
  return false;
}

export const asyncTimeout = sec => new Promise((resolve) => {
  setTimeout(() => {
    resolve()
  }, sec * 1000)
})

export const getApartmentId = (str) => {
  const arr = str.split(',')
  return arr.length === 4 ? arr[3] : null
}

export const setPressHandlers = function (cb) {
  return {
    tabIndex: 0,
    onClick: cb,
    onKeyPress: function (e) {
      if (e.charCode === keyCodes.space || e.charCode === keyCodes.enter) {
        cb(e)
      }
    }
  }
}

export const renderBrandStatement = (position) => {
  const brandStatement = window?.drupalSettings?.brandStatement || ''
  if (brandStatement.position === position) {
    return (
      <BrandingWidget
        image={brandStatement.image_link}
        content={brandStatement.text}
      />
    )
  }
  return null
}

export const removeTags = (str) =>{
  if ((str===null) || (str===''))
    return false;
  else
    str = str.toString();

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace( /(<([^>]+)>)/ig, '');
}

// Function to check if the value exists in the array of objects
export const containsValue = (arr, propertyName, searchValue) => {
  return arr.some(item => item[propertyName] === searchValue);
}
